/**
 * Utilitários para timeout de fetch com compatibilidade ampla entre navegadores.
 */

interface ControleTimeoutFetch {
  signal: AbortSignal;
  limpar: () => void;
}

// Function-level comment: Cria um AbortSignal com timeout usando AbortController,
// evitando dependência de `AbortSignal.timeout` (API nativa), que falha em alguns Safari/iOS.
function criarControleTimeoutFetch(tempoLimiteMs: number): ControleTimeoutFetch {
  const controladorAbort = new AbortController();

  const identificadorTimeout = globalThis.setTimeout(() => {
    try {
      controladorAbort.abort(new DOMException('Tempo limite excedido', 'TimeoutError'));
    } catch {
      controladorAbort.abort();
    }
  }, tempoLimiteMs);

  return {
    signal: controladorAbort.signal,
    limpar: () => globalThis.clearTimeout(identificadorTimeout),
  };
}

// Function-level comment: Executa um `fetch` com timeout compatível com Safari/iPhone,
// limpando o temporizador assim que a resposta HTTP é recebida.
export async function fetchComTimeout(
  entrada: RequestInfo | URL,
  opcoes: RequestInit = {},
  tempoLimiteMs = 10000
): Promise<Response> {
  const controleTimeout = criarControleTimeoutFetch(tempoLimiteMs);

  try {
    return await fetch(entrada, {
      ...opcoes,
      signal: opcoes.signal ?? controleTimeout.signal,
    });
  } finally {
    controleTimeout.limpar();
  }
}
